import { useFileUploadActivity } from '@/context/FileUploadActivityContext';
import { useTilesetUpload } from '@/context/TilesetUploadContext';

/**
 * True while any browser -> server transfer is in flight, whether it is a 3D
 * model or a plain file. Upload entry points disable themselves on this so a
 * second transfer cannot be started on top of a running one.
 *
 * Server-side tileset processing deliberately does not count: it no longer
 * occupies the browser and never blocked starting another upload.
 */
export function useUploadBusy(): boolean {
	const { isUploading: isTilesetUploading } = useTilesetUpload();
	const { isFileUploading } = useFileUploadActivity();
	return isTilesetUploading || isFileUploading;
}
